<h1 mat-dialog-title>{{data.title}}</h1>
<mat-dialog-content class="dialog-content">
  <span [innerHtml]="data.message"></span>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!data.preventClosing" class="dialog-actions">
  <button [mat-dialog-close]="true" mat-stroked-button color="primary">Close</button>
</mat-dialog-actions>
